<template>
  <div class="check-work-body">
    <template>
      <el-tabs v-model="activeName" @tab-click="handleClick">

        <div class="search-wrap">
          <template v-if="modelData.is_sync === 0">
            <el-button size="mini" type="primary" style="margin-right: 5px;" @click="editField(null)">添加模型字段</el-button>
            <el-button size="mini" type="danger" style="margin-right: 5px;"  @click="syncDatabase(null)">同步数据库表</el-button>
          </template>
        </div>
        <el-tab-pane label="数据库属性" name="fieldTableTag">
          <div v-show="true">
          <div class="table-wrap">

            <el-table v-if="fieldList" v-loading="loading" :data="fieldList">
              <el-table-column prop="field_name" label="字段名称" align="center"></el-table-column>
              <el-table-column prop="field_description" label="字段描述" align="center"></el-table-column>
              <el-table-column prop="type" label="字段类型" align="center"></el-table-column>
              <el-table-column prop="options" label="字段配置" align="center"></el-table-column>
              <el-table-column prop="is_null" label="允许空值" align="center">
                <template slot-scope="scope">
                  {{scope.row.is_null?'可空':'非空'}}
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="300">
                <template slot-scope="scope">
                  <el-button type="primary" v-show="scope.row.is_edit === true" size="mini" icon="el-icon-s-order"  @click="editField(scope.row)">编辑</el-button>
                  <template v-if="modelData.is_sync === 0">
                    <el-button type="danger"  v-show="scope.row.is_del === true" size="mini" icon="el-icon-error" @click="delField(scope.row.field_name)">删除</el-button>
                  </template>
                </template>
              </el-table-column>
            </el-table>

          </div>
        </div>
        </el-tab-pane>
        <el-tab-pane label="模型字段" name="fieldTableTag2">模型字段</el-tab-pane>
      </el-tabs>
    </template>


    <!-- 修改/添加 窗口字段窗口 -->
    <el-dialog title="编辑" :visible.sync="dialogVisibleField" :close-on-click-modal="false" width="600px">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-form :model="form" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-form-item label="字段名" prop="title">
            <el-input class="form-input" v-model="form.field_name" :disabled="fieldNotEdit" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="数据名称" prop="title">
            <el-input class="form-input" v-model="form.field_description" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="数据类型" prop="title">
            <el-input class="form-input" v-model="form.type" :disabled="fieldNotEdit" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="数据配置" prop="title">
            <el-input type="text" class="form-input" v-model="form.options" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleField = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" >确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>

import Http from "./common/Http";

export default {
  name:"FlowModelList",
  data () {
    return {
      activeName: 'fieldTableTag',
      loading: false,
      dialogVisible: false,
      dialogVisibleField:false,
      fieldNotEdit:true,
      fieldList: [],
      fieldJson: {},
      modelData: {},
      form: {
        type: "",
        field_description: "",
        options: "",
        field_name: "test4",
        is_edit : true,
        is_show : true,
        is_null : true,
        is_del : true,
      },
      query: this.$route.query
    }
  },
  created() {
    
  },
  activated() {
    this.query = this.$route.query
    this.getData()
  },
  watch: {

  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 获取数据模型
    getData() {
      var that=this;
      that.loading=true;
      Http.get("flow/FlowModel/detailModel",{
        model_id : this.query.model_id
      },res=>{
        that.loading=false;
        if(res.code) {
          that.modelData=res.data
          that.fieldJson = res.data.field_json
          that.fieldList = _.map(res.data.field_json, function (value) {
            return value;
          })
        } else {
          alert(res.msg);
        }
      })
    },
    delField(field_name) {
      var that=this;
      that.loading=true;
      Http.get("flow/FlowModel/delField",{
        model_id : this.query.model_id,
        field_name : field_name
      },res=>{
        console.log(res)
        that.loading=false;
        if(res.code) {
          this.getData();
          console.log(that.fieldList)
        } else {
          alert(res.msg);
        }
      })
    },
    editField(item) {

      if (item == null) {
        this.fieldNotEdit = false
        this.form = {
          type: "",
          field_description: "",
          options: "",
          field_name: "",
          is_edit : true,
          is_show : true,
          is_null : true,
          is_del : true,
        }
      } else {
        this.fieldNotEdit = true
        this.form = item
      }
      this.dialogVisibleField = true
    },
    submitForm(formName) {
      var that=this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.formLoading = true
          let data = Object.assign({}, this.form)
          data.model_id = this.query.model_id
          Http.post("flow/FlowModel/saveField",data,res => {
            that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
            if(res.code) {
              that.dialogVisibleField = false
              that.getData()
            }
            that.formLoading = false
          })
        } else {
          return false;
        }
      });
    },
    syncDatabase(){
      var that=this;
      that.loading=true;
      Http.get("flow/FlowModel/syncModelDataBase",{
        model_id : this.query.model_id
      },res=>{
        that.loading=false;
        if(res.code) {
          this.getData();
        } else {
          alert(res.msg);
        }
      })

      console.info(this.query.model_id)
      console.info(this.modelData)
    },
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 200px );
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/FlowModelDetail.vue